const WD = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export const addDays = (iso, n) => { const d = new Date(`${iso}T00:00:00Z`); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };
export const weekday = (iso) => WD[new Date(`${iso}T00:00:00Z`).getUTCDay()];
export const shortDate = (iso) => new Date(`${iso}T00:00:00Z`).toLocaleString("en-GB", { day: "2-digit", month: "short", timeZone: "UTC" }).replace("Sept", "Sep");

export function dayOff(d, cal) {
  if (cal.workingDays.some((w) => w.date === d)) return null;
  const h = cal.holidays.find((x) => x.date === d);
  if (h) return h.name;
  const w = weekday(d);
  return w === "Saturday" || w === "Sunday" ? w : null;
}
